<template>
    <div class="d-flex justify-content-center">
        <div>
            <p class="text-center my-2" v-if="textPosition === 'top'">{{ title }}</p>
            <div class="number d-flex align-items-center justify-content-center"><span class="percentage inverse">{{ count }}</span>
            </div>
            <p class="text-center my-2" v-if="textPosition === 'bottom'">{{ title }}</p>
        </div>
    </div>
</template>

<style lang="sass" scoped>
    $primary: #0374d7
    .number
        background-color: $primary
        border-radius: 100px
        margin: 6px 5px 12px
        color: white
        width: 90px
        height: 90px
        text-align: center

    .percentage
        font-size: 1.3rem
        color: $primary

        &.inverse
            color: white
</style>


<script>
    export default {
        props: {
            title: {required: true},
            count: {required: true},
            textPosition: {default: 'top'},
        }
    };
</script>
